import {createOrders$} from '@/spot-utils/orders';
import {woMsg$} from '@/raw/wo';
import {toUiMsg$} from '@/ui';
import type {ws} from '@/types';
type SpotOrders = ws.SpotOrders;

export interface UOrdersSpot {
  type: 'incremental-order';
  data: {
    incremental: true;
    wo: SpotOrders;
  };
}

export const {orders$: spotOrders$, snapshotOrders$, incrementalOrders$} = createOrders$<SpotOrders>(woMsg$);

incrementalOrders$.subscribe((wo) => toUiMsg$.next({type: 'incremental-order', data: {incremental: true, wo}}));
